import {
    Room,
    RoomModel,
} from '../common/models/RoomModel.js'
import { View } from './view.js'


export class Api {
    view: View

    constructor(view: View) {
        this.view = view
    }

    async fetchRooms() {
        try {
            this.view.startLoading()

            const response = await fetch('/api/v1/rooms/list')
            const data = await response.json() as Room[]

            if (!response.ok) {
                throw new Error('Failed to fetch rooms')
            }

            this.view.state.rooms = data.map(room => new RoomModel(room))
            this.view.update()
        } catch (err) {
            this.view.state.latestError = (err instanceof Error ? err.message : 'Failed to fetch rooms')
            this.view.state.rooms = []
        } finally {
            this.view.endLoading()
        }
    }
}

export const createApi = (view: View): Api => {
    return new Api(view)
}
